import React from 'react';
import { Helmet } from 'react-helmet-async';

export type SEOProps = {
  title?: string;
  description?: string;
  keywords?: string[];
  canonical?: string;
  image?: string;
  noindex?: boolean;
  jsonLd?: object | object[];
};

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  image,
  noindex,
  jsonLd,
}: SEOProps) {
  const siteName = 'CosmaComply';
  const url = canonical || (typeof window !== 'undefined' ? window.location.href : undefined);

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(', ')} />
      )}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:site_name" content={siteName} />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}

      {/* Structured data */}
      {jsonLd && (
        <script type="application/ld+json">
          {Array.isArray(jsonLd)
            ? JSON.stringify(jsonLd)
            : JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
